import { FC, useEffect } from "react";

import { Link, Stack, Typography } from "@mui/material";

import {
  getRouteFormProperty,
  setRouteFormProperties,
} from "../../../../../slices/routes";
import { useDispatch, useSelector } from "../../../../../store";
import { downloadFile } from "../../../../../utils/downloadFile";
import CodeSnippet from "@/components/CodeSnippet";

export const AddConfig: FC = () => {
  const dispatch = useDispatch();
  const from = useSelector(getRouteFormProperty("from", "")) as string;
  const fromHostname = new URL(from)?.hostname;
  useEffect(() => {
    const updates = [
      {
        path: "setRequestHeaders.Authorization",
        value: "Bearer ${pomerium.jwt}",
      },
      { path: "jwtIssuerFormat", value: "uri" },
    ];
    dispatch(setRouteFormProperties(updates));
  }, []);

  const config = `apiVersion: apiserver.config.k8s.io/v1beta1
kind: AuthenticationConfiguration
jwt:
  - issuer:
      url: https://${fromHostname}/
      discoveryURL: https://${fromHostname}/.well-known/pomerium
      audiences:
        - ${fromHostname}
    claimMappings:
      username:
        claim: email
        prefix: ""`;

  return (
    <Stack spacing={2}>
      <Typography>
        Copy or{" "}
        <Link
          sx={{ cursor: "pointer" }}
          onClick={() => downloadFile(config, "text/yaml", "config.yaml")}
        >
          download
        </Link>{" "}
        the config and then follow the docs{" "}
        <Link
          target="_blank"
          href="https://kubernetes.io/blog/2024/04/25/structured-authentication-moves-to-beta/#how-to-use-structured-authentication-configuration"
        >
          here
        </Link>{" "}
        to configure your api server.
      </Typography>
      <CodeSnippet code={config} copyInfo="kubernetes_config" />
    </Stack>
  );
};
